import {computed} from 'vue';
import type {RouteResolversFn} from '@navbar/common/composables';
import {useLocationWatcher} from '@navbar/common/composables';
import {useLocalePrefix} from '#imports';
import {SearchDisplayMode} from '../search.types';

export type PossibleSearchPages =
    'Profile' | 'Playground' | 'Search' | 'AllFreelances' | 'Seo-tags' | 'find-freelancers' | 'Job-description' | 'ConversationalAgent';

export type PagePattern = {
    name: PossibleSearchPages;
    isActiveWhen: (resolvers: RouteResolversFn) => boolean;
    /**
     * Pass to true if you don't want header to overlap on content
     * @default false
     */
    pushContent?: boolean;
    searchDisplayMode: SearchDisplayMode;
};

export function useSearchRouteDefinitions() {
    const {routeUtils} = useLocationWatcher();
    const {withLocalePrefix} = useLocalePrefix();

    const pagesPatterns: PagePattern[] = [
        {
            name: 'Profile',
            searchDisplayMode: SearchDisplayMode.FORM,
            pushContent: true,
            isActiveWhen: ({startWith}) => startWith(withLocalePrefix('/profile')),
        },
        {
            name: 'Playground',
            searchDisplayMode: SearchDisplayMode.FORM,
            isActiveWhen: ({startWith}) => startWith(withLocalePrefix('/navbar-playground')),
        },
        {
            name: 'Search',
            searchDisplayMode: SearchDisplayMode.FORM,
            pushContent: true,
            isActiveWhen: ({exact}) => exact(withLocalePrefix('/s')) || exact(withLocalePrefix('/s/')),
        },
        {
            name: 'AllFreelances',
            searchDisplayMode: SearchDisplayMode.FORM,
            isActiveWhen: ({exact}) => exact(withLocalePrefix('/all-freelances')),
        },
        {
            name: 'Seo-tags',
            searchDisplayMode: SearchDisplayMode.FORM,
            isActiveWhen: ({startWith}) => startWith(withLocalePrefix('/s/tags/')),
        },
        {
            name: 'find-freelancers',
            searchDisplayMode: SearchDisplayMode.NONE,
            isActiveWhen: ({exact}) => exact(withLocalePrefix('/project-client/find-freelancers')),
        },
        {
            name: 'Job-description',
            searchDisplayMode: SearchDisplayMode.NONE,
            isActiveWhen: ({startWith}) => startWith(withLocalePrefix('/s/advanced')),
        },
        {
            name: 'ConversationalAgent',
            searchDisplayMode: SearchDisplayMode.NONE,
            isActiveWhen: ({startWith}) => startWith(withLocalePrefix('/agent')),
        },
    ];

    const currentPage = computed(() => pagesPatterns.find((f) => !!f.isActiveWhen(routeUtils)));

    return {
        currentPage,
    };
}
